<template>
  <div class="step-one">
    <el-form @submit.native.prevent>
      <el-form-item
        label="查询条件"
        v-if="newSearchParams && newSearchParams.length > 0"
        :style="{ 'margin-bottom': showSearchStatusBtn ? 0 : '24px' }"
      >
        <div
          :class="[
            'flexible-box',
            searchStatus === 'close'
              ? showSearchStatusBtn
                ? 'close'
                : ''
              : 'open',
          ]"
        >
          <div class="searchBox-list" ref="searchBox">
            <template v-for="(item, index) in newSearchParams">
              <p v-if="!item.hidden" :key="index">
                <span class="title">{{ item.label }}：</span>
                <el-tooltip
                  v-if="
                    Array.isArray(item.matchValue) && item.matchValue.length > 1
                  "
                  :content="item.matchValue.join('、')"
                  placement="bottom"
                  effect="light"
                >
                  <span
                    >{{ item.matchValue[0] }} +
                    {{ item.matchValue.length - 1 }}</span
                  >
                </el-tooltip>
                <span
                  style="color: #606266"
                  v-else-if="
                    Array.isArray(item.matchValue) &&
                    item.matchValue.length === 1
                  "
                  >{{ item.matchValue[0] }}
                </span>
                <span style="color: #606266" v-else>{{ item.matchValue }}</span>
              </p>
            </template>
          </div>
        </div>
      </el-form-item>
      <el-form-item label=" " v-if="showSearchStatusBtn">
        <div class="operate-btn" @click="openOrCloseSearchContainer">
          {{ searchStatus === 'close' ? '展开' : '收起' }}
          <i
            :class="
              searchStatus === 'close'
                ? 'el-icon-arrow-down'
                : 'el-icon-arrow-up'
            "
          ></i>
        </div>
      </el-form-item>
      <!-- 前端展示的导出字段不影响导出结果 -->
      <el-form-item
        label="导出字段"
        :style="{ 'margin-bottom': showExportStatusBtn ? 0 : '24px' }"
      >
        <div
          :class="[
            'flexible-box',
            exportTypeStatus === 'close'
              ? showExportStatusBtn
                ? 'close'
                : ''
              : 'open',
          ]"
        >
          <div class="exportBox-list" ref="exportBox">
            <span
              v-for="(item, index) in exportColumns"
              :key="index"
              class="export-header"
              >{{ item.label }}</span
            >
          </div>
        </div>
      </el-form-item>
      <el-form-item
        label=" "
        v-if="showExportStatusBtn"
        style="margin-bottom: 0"
      >
        <div class="operate-btn" @click="openOrCloseExportType">
          {{ exportTypeStatus === 'close' ? '展开' : '收起'
          }}<i
            :class="
              exportTypeStatus === 'close'
                ? 'el-icon-arrow-down'
                : 'el-icon-arrow-up'
            "
          ></i>
        </div>
      </el-form-item>
      <el-form-item label="导出说明">
        <!-- 业务导出 -->
        <div class="flexible-box explain">
          1、操作导出后，可点击<a @click="handleGoExportHistory">查询导出结果</a
          >查看导出结果。<br />
          2、数据处理完成后生成的excel文件，您可以将文件下载到电脑本地。
        </div>
      </el-form-item>
    </el-form>
  </div>
</template>

<script setup>
import { ref, watch, nextTick, computed } from 'vue'

const props = defineProps({
  newSearchParams: {
    type: Array,
    default: () => [],
  },
  columns: {
    type: Array,
    default: () => [],
  },
})
const searchStatus = ref('close')
const exportTypeStatus = ref('close')
const showSearchStatusBtn = ref(false)
const showExportStatusBtn = ref(false)

const searchBox = ref(null)
const exportBox = ref(null)

const exportColumns = computed(() => {
  return props.columns.filter((element) => element.name !== 'operate')
})
watch(
  () => props.newSearchParams,
  () => {
    nextTick(() => {
      getStatus()
    })
  },
  {
    deep: true,
    immediate: true,
  },
)
function getStatus() {
  if (searchBox.value && searchBox.value.offsetHeight > 88) {
    showSearchStatusBtn.value = true
  } else {
    showSearchStatusBtn.value = false
  }
  if (exportBox.value && exportBox.value.offsetHeight > 88) {
    showExportStatusBtn.value = true
  } else {
    showExportStatusBtn.value = false
  }
}
function openOrCloseSearchContainer() {
  if (searchStatus.value === 'close') {
    searchStatus.value = 'open'
  } else {
    if (searchBox.value) {
      searchBox.value.scrollTop = 0
    }
    searchStatus.value = 'close'
  }
}
function openOrCloseExportType() {
  if (exportTypeStatus.value === 'close') {
    exportTypeStatus.value = 'open'
  } else {
    if (exportBox.value) {
      exportBox.value.scrollTop = 0
    }
    exportTypeStatus.value = 'close'
  }
}
const emit = defineEmits(['openHistory'])
function handleGoExportHistory() {
  emit('openHistory')
}
</script>
<style lang="scss" scoped>
.export-tips {
  line-height: 44px;
  border: 1px solid #6696df;
  background: #f1f6f9;
  padding: 0 20px;
  color: #333;
  margin-bottom: 20px;
  .el-icon-warning {
    color: #1c75ff;
  }
}
.close {
  height: 80px;
  overflow: hidden;
}
.h112 {
  height: 80px;
  overflow: hidden;
}
.open {
  overflow-y: auto;
}
.operate-btn {
  color: #1c75ff;
  cursor: pointer;
}
.flexible-box {
  line-height: 30px;

  overflow-x: hidden;
  p {
    display: inline-block;
    margin: 0 10px 10px 0;
    border-radius: 4px;
    background-color: #f1f2f5;
    padding: 0px 10px;
    font-size: 12px;
    .title {
      color: #303133;
      font-weight: 400;
    }
  }

  .export-header {
    display: inline-block;
    margin: 0 10px 10px 0;
    padding: 0px 10px;
    background-color: #f1f2f5;
    border-radius: 4px;
    white-space: nowrap;
    font-size: 12px;
    color: #303133;
    font-weight: 400;
  }
}
.explain {
  // height: 80px;
  color: #333;
  line-height: 22px;
  font-size: 13px;
  padding: 6px 0;
}
.agreementBox {
  margin-left: 100px;
}
.includeToady {
  color: #ff5964 !important;
}
</style>
